import React, { Dispatch, SetStateAction } from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';

import { BackflowLog } from '../../model';

interface BackflowLogFormCommentOnlyProps {
  formValues: BackflowLog;
  setFormValues: Dispatch<SetStateAction<BackflowLog>>;
}

const BackflowLogFormCommentOnly: React.FC<BackflowLogFormCommentOnlyProps> = (props) => {
  const { formValues, setFormValues } = props;

  // This version of the comment field doesn't include the 'optional' in parentheses

  return (
    <Card>
      <CardContent>
        <TextField
          rows={5}
          multiline
          label="Internal Comment"
          value={formValues.internal_comment}
          onChange={(e) => setFormValues({ ...formValues, internal_comment: e.target.value })}
          InputLabelProps={{ shrink: true }}
          fullWidth
          sx={{ mb: 3 }}
        />
      </CardContent>
    </Card>
  );
};

export default BackflowLogFormCommentOnly;
